import React from 'react';
import { Route } from 'react-router-dom';
import Users from '../pages/users/Users';
import CreateUsers from '../pages/users/CreateUsers';
import EditUsers from '../pages/users/EditUsers';
import PermissionGuard from '../components/global/PermissionGuard';

const usersRoutes = (
    <>
        <Route
            path="/users"
            element={
                <PermissionGuard permission="users_list">
                    <Users />
                </PermissionGuard>
            }
        />

        <Route
            path="/users/create"
            element={
                <PermissionGuard permission="users_create">
                    <CreateUsers />
                </PermissionGuard>
            }
        />

        <Route
            path="/users/:id/edit"
            element={
                <PermissionGuard permission="users_edit">
                    <EditUsers />
                </PermissionGuard>
            }
        />
    </>
);

export default usersRoutes;
